<template>
    <div
        v-if="galleryIsVisible"
        class="border border-primary bg-white rounded-2xl p-4 w-full xl:w-[430px]"
        :class="{'xl:w-[330px]' : miniatureMode}"
    >
        <div>
            <Carousel :photos="gallery.pictures || []" />
            <div class="relative">
                <div
                    class="absolute right-4 bottom-4 cursor-pointer hover:bg-white"
                    @click="showInModal(gallery.pictures)"
                >
                    <Icon name="Expandir" />
                </div>
            </div>
        </div>
        <div class="mt-5 flex w-full">
            <div class="flex flex-col gap-y-3 w-full">
                <div>
                    <div v-if="contestStage != 4" class="flex justify-center">
                        <div class="border border-primary rounded-2xl px-4 py-2 flex">
                            <div class="border-r border-gray-400 pr-4">
                                <h1 class="text-xs text-center">Aprovar</h1>
                                <div class="flex gap-x-1.5">
                                    <div v-for="(star, key) in [1, 2, 3]" :key="key">
                                        <label
                                            v-bind:class="{
                                                'cursor-pointer': isAllowedToVote,
                                            }"
                                            @mouseenter="
                                                gallery.tempValue =
                                                    getCurrentStarValue(star)
                                            "
                                            @mouseleave="
                                                gallery.tempValue =
                                                    gallery.validation?.level
                                            "
                                        >
                                            <Icon
                                                name="EstrelaHover"
                                                :disabled="isAllowedToVote"
                                                :isFill="
                                                    isAllowedToVote
                                                        ? (gallery.tempValue ||
                                                            gallery.validation?.level) >=
                                                        star
                                                        : gallery.validation?.level >= star
                                                "
                                                @click="vote(star)"
                                            />
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div v-if="Boolean(gallery.isVisible)" class="pl-4">
                                <h1 class="text-xs text-center">Ocultar</h1>
                                <div @click="updateVisibilityGallery(gallery)" class="flex gap-x-1.5 cursor-pointer">
                                    <Icon class="hover:text-error text-gray-500 h-4" name="Minus"/>
                                </div>
                            </div>
                            <div v-else class="pl-4">
                                <h1 class="text-xs text-center">Mostrar</h1>
                                <div @click="updateVisibilityGallery(gallery)" class="flex gap-x-1.5 cursor-pointer">
                                    <Icon class="hover:text-error text-gray-500 h-4" name="Plus"/>
                                </div>
                            </div>
                        </div>
                        <link
                            rel="stylesheet"
                            href="//maxcdn.bootstrapcdn.com/font-awesome/4.3.0/css/font-awesome.min.css"
                        />
                    </div>
                    <div v-if="gallery.validation?.positionStage2 && contestStage > 2" class="flex border rounded-2xl p-2 items-center justify-between">
                        Nível 2
                        <div class="flex gap-x-2">
                            <div class="border rounded-full h-8 px-2 flex justify-center items-center bg-primary text-white">
                                {{ computedStage2Badge }}
                            </div>
                            <div class="border rounded-full w-8 h-8 flex justify-center items-center bg-primary text-white">
                                {{ gallery.validation?.positionStage2 }}º
                            </div>
                        </div>
                    </div>
                    <div v-if="gallery.validation?.positionStage3 && contestStage > 3" class="flex border rounded-2xl p-2 items-center justify-between">
                        Nível 3
                        <div class="flex gap-x-2">
                            <div class="border rounded-full h-8 px-2 flex justify-center items-center bg-primary text-white">
                                {{ computedStage3Badge }}
                            </div>
                            <div class="border rounded-full w-8 h-8 flex justify-center items-center bg-primary text-white">
                                {{ gallery.validation?.positionStage3 }}º
                            </div>
                        </div>
                    </div>
                    <div v-if="canVotePodium" class="flex flex-col gap-y-3">
                        <div class="flex flex-col">
                            <h1 class="text-primary font-bold">Ranking das Melhores Fotos</h1>
                            <div class="flex">
                                <SelectRanking
                                    class="max-w-[300px]"
                                    :options="totalPositionsList"
                                    :optionsFree="positions"
                                    v-model.number="gallery.validation[`positionStage${contestStage}`]"
                                    @input="saveRanking($event.target.value)"
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="!miniatureMode" class="flex flex-col gap-y-3 w-full">
                    <div>
                        <div class="flex items-center gap-x-2">
                            <h1 class="text-primary font-bold">Participante(s)</h1> 
                        </div>
                        <p @click="showParticipants()" class="cursor-pointer hover:underline hover:text-blue-500">{{ gallery.userCreated?.name }}</p>
                    </div>
                    <div>
                        <h1 class="text-primary font-bold">Sold</h1>
                        <p>{{ gallery.pdv?.codeSoldBroker }}</p>
                    </div>
                    <div>
                        <h1 class="text-primary font-bold">
                            Regional / Sub-regional
                        </h1>
                        <p>
                            {{ gallery.pdv?.region }} /
                            {{ gallery.pdv?.subregion.name }}
                        </p>
                    </div>
                    <div>
                        <h1 class="text-primary font-bold">Canal</h1>
                        <p>{{ gallery.pdv?.canal }}</p>
                    </div>
                    <div>
                        <h1 class="text-primary font-bold whitespace-nowrap">
                            Tipo de Execução
                        </h1>
                        <p>{{ gallery.executionType?.description }}</p>
                    </div>
                    <div>
                        <h1 class="text-primary font-bold">Campanha</h1>
                        <p>{{ handleContestName(gallery.contest) }}</p>
                    </div>
                    <div>
                        <h1 class="text-primary font-bold">Categoria</h1>
                        <p v-if="gallery.categories?.length === 0">NÃO ENCONTRADO</p>
                        <p v-for="(category, key) in handleSubcategories(gallery.categories)" :key="key">{{ category }}</p>
                    </div>
                    <div>
                        <h1 class="text-primary font-bold">Senha Semanal</h1>
                        <p>{{ gallery.weeklypassphrase }}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- <Gallery :gallery="currentGallery"/> -->
</template>

<script>
import moment from "moment";
import { Head } from "@inertiajs/inertia-vue3";
import Heading from "@/Components/UI/Texts/Heading.vue";
import Icon from "@/Components/UI/Icons/Icon.vue";
import Button from "@/Components/Button.vue";
import Authenticated from "@/Layouts/Authenticated.vue";
import Gallery from "@/Components/Gallery.vue";
import Carousel from "@/Components/CarouselSimple.vue";
import SelectRanking from "@/Components/UI/Form/SelectRanking.vue";

export default {
    components: {
        Authenticated,
        Head,
        Heading,
        Head,
        Icon,
        Button,
        Gallery,
        Carousel,
        SelectRanking,
    },

    emits: ["updateVote", "updateRanking", "showParticipants"],

    props: {
        currentVoteCount: Number,
        contests: Object,
        gallery: Object,
        showInModal: Function,
        positions: Object,
        contestStage: Number,
        currentContest: Object,
        miniatureMode: {
            type: Boolean,
            default: false
        },
        totalPositionsList: Object,
    },


    data() {
        return {
            galleryIsVisible: true
        };
    },

    watch: {
        'gallery.validation': {
            handler(newValue, oldValue) {
                const newPosition = newValue[`positionStage${this.contestStage}`];
                const oldPosition = oldValue[`positionStage${this.contestStage}`];
                
                if(newPosition != oldPosition) {
                    this.$emit("updateRanking", {
                        id: this.gallery.id,
                        loading: false,
                    });
                }
            },
            deep: true
        }
    },

    computed: {
        computedStage2Badge() {
            const contest = this.contest;

            if(!contest) {
                return 'N/A' 
            }

            if(contest.winningType == "S") {
                return this.gallery.pdv?.subregion.name;
            } else {
                return this.gallery.pdv?.region;
            }
        },
        computedStage3Badge() {
            const contest = this.contest;

            if(!contest) {
                return 'N/A' 
            }

            if(contest.winningType == "S") {
                return this.gallery.pdv?.subregion.name;
            }
            if(contest.winningType == "R") {
                return this.gallery.pdv?.region;
            }
            if(contest.winningType == "N") {
                return "NACIONAL";
            }
        },
        canVotePodium() {
            switch (this.contestStage) {
                case 2:
                    return this.gallery.validation?.level >= 2;
                    break;
                case 3:
                    return this.gallery.validation?.level >= 3;
                    break;
                case 4:
                    return true;
                    break;
            }
        },
        maxVotes() {
            switch (this.contestStage) {
                case 2:
                    return ((this.contest?.qtdWinningPictures || 0) + (this.contest?.qtdPodiumPictures || 0)) * 2;
                    break;
                case 3:
                    return ((this.contest?.qtdWinningPictures || 0) + (this.contest?.qtdPodiumPictures || 0));
                    break;
                case 4:
                    return ((this.contest?.qtdPodiumPictures || 0));
                    break;
                default:
                    return ((this.contest?.qtdWinningPictures || 0) + (this.contest?.qtdPodiumPictures || 0)) * 2;
                    break;
            }
        },
        isAllowedToVote() {
            const contest = this.contest;
            const gallery = this.gallery;

            let responsible;
            const contests = this.$page.props.auth.user.contestJudges;
             if (String(contest?.reopening ?? 'N').toUpperCase() === 'S') {
                return true;
            }

            if (Number(this.maxVotes) <= Number(this.currentVoteCount) && (this.getCurrentStarValue(gallery.validation?.level || 0) != this.contestStage)) return false;

            switch (this.contestStage) {
                case 1:
                    responsible = contests?.find((item) => {
                        return contest.id === item.contestId && item.stage == 1;
                    });
                    break;
                case 2:
                    responsible = contests?.find((item) => {
                        return contest.id === item.contestId && item.stage == 2;
                    });
                    break;
                case 3:
                    responsible = contests?.find((item) => {
                        return contest.id === item.contestId && item.stage == 3;
                    });
                    break;
                case 4:
                    responsible = contests?.find((item) => {
                        return contest.id === item.contestId && item.stage == 4;
                    });
                    break;
            }

            return responsible;
        },
        contest() {
            return this.currentContest;
        },
        computedContest() {
            return this.campaigns.map((contest) => ({
                ...contest,
                name: this.handleName(contest),
                id: contest.id,
            }));
        },
        isVoted() {
            if(this.contestStage < 4) {
                if(this.gallery.validation.level == this.contestStage) {
                    return true;
                }

                return false;
            }
        }
    },
    methods: {
        handleContestName(contest) {
            return `${contest.name} (${moment(contest.startDate)
                .locale("pt-br")
                .format("MMM")
                .toUpperCase()} à ${moment(contest.endDate)
                .locale("pt-br")
                .format("MMM")
                .toUpperCase()})`;
        },
        getCurrentStarValue(star) {
            const contest = this.contest;
            if (star >= this.contestStage) {
                return this.contestStage;
            } else if (star < this.contestStage - 1) {
                return this.contestStage - 1;
            } else {
                return star;
            }
        },
        vote() {
            if (!this.isAllowedToVote) return;

            if (this.gallery.isVisible === 0) {
                this.$page.props.flash.error = "Não é possível votar em foto ocultada.";
                return;
            };

            const gallery = this.gallery;

            this.$emit("updateVote", { id: gallery.id, loading: true });

            axios
                .put(this.route("save-vote"), {
                    galleryId: gallery.id,
                })
                .then(({ data }) => {
                    gallery.validation = data.validation;
                    gallery.tempValue = data.newLevel;

                    this.$emit("updateVote", {
                        id: gallery.id,
                        loading: false,
                    });

                }).catch((err) => console.log(err));
        },
        saveRanking($event) {
            if (!this.isAllowedToVote) return;

            if (this.gallery.isVisible === 0) {
                this.$page.props.flash.error = "Não é possível atualizar o ranking em foto ocultada.";
                return;
            };

            const gallery = this.gallery;
            gallery.position = $event;

            this.$emit("updateRanking", { id: gallery.id, loading: true });

            axios
                .put(this.route("save-ranking"), {
                    galleryId: gallery.id,
                    podiumPosition:
                        gallery.position == "N/A" ? 0 : gallery.position,
                })
                .then(({ data }) => {
                    this.$emit("updateRanking", {
                        id: gallery.id,
                        loading: false,
                    });
                });
        },
        handleCategories(categories) {
            if(!categories) {
                return []
            }

            return categories?.reduce((previous, current) => {
                if(previous.find((el) => el === current.group) === undefined) {
                previous.push(current.group);
                }
                return previous;
            }, []);
        },
        handleSubcategories(categories) {
            return categories.map(el => el.description)
        },
        updateVisibilityGallery(gallery) {
            if(Boolean(gallery.isVisible) && this.isVoted) {
                this.$page.props.flash.error = "Não é possível ocultar uma execução que foi votada.";
                return;
            }

            const newIsVisible = !Boolean(gallery.isVisible);
            const newGallery = Object.assign(gallery);
            newGallery.isVisible = newIsVisible;

            axios.put(route("gallery.save-visibility"), {gallery: newGallery})
                .then(response => {
                    if(response.status === 200) {
                        this.galleryIsVisible = false;
                    }
                });
        },
        showParticipants() {
            this.$emit('showParticipants', this.gallery.participants);
        }
    },
};
</script>
<style scoped>
/* Hide scrollbar for Chrome, Safari and Opera */
/* .no-scroll-bar::-webkit-scrollbar {
    display: none;
} */

/* Hide scrollbar for IE, Edge and Firefox */
/* .no-scroll-bar {
    -ms-overflow-style: none;
    scrollbar-width: none;
} */
</style>
